import z from "zod";
import { EDocumentVerificationStatus, EKycDocumentType } from "../constants";
import { partnerResponseDtoSchema } from "./partner";
import { AdminTaskResponseDto } from "./task";

/**
 * KYC document information schema
 */
export const kycDocumentInfoSchema = z.object({
    documentType: z.nativeEnum(EKycDocumentType),
    documentUrl: z.string(),
    documentNumber: z.string(),
    verificationStatus: z.nativeEnum(EDocumentVerificationStatus),
    submittedAt: z.coerce.number().int().positive(),
});

/**
 * Partner KYC task data DTO schema
 * Contains partner info and array of pending documents
 */
export const partnerKycTaskResponseDtoSchema = z.object({
    partner: partnerResponseDtoSchema,
    documents: z.array(kycDocumentInfoSchema),
    city: z.string(),
});

export type IPartnerKycTaskResponseDto = z.infer<typeof partnerKycTaskResponseDtoSchema>;
export type IKycDocumentInfo = z.infer<typeof kycDocumentInfoSchema>;

/**
 * Type alias for AdminTaskResponseDto with Partner KYC data
 */
export type IPartnerKycTask = AdminTaskResponseDto<IPartnerKycTaskResponseDto>;
